import axiosApiInstance from '@/api/shared/axios-instance';
import NoticiasFlashSingleComponent from '@/components/noticias-flash/noticias-flash-single-component';
import SeoNoticiasFlash from '@/components/noticias-flash/seo-noticias-flash';
import { Rutas } from '@/constants/rutas';
import { obtenerEquipo } from '@/data/equipos';
import { getMasterBigPhotoById } from '@/helpers/images-helper';
import { getPlayersStatus } from '@/helpers/players-helper';
import { Box, Typography } from '@mui/material';

const NoticiasFlashSinglePage = ({ noticia }) => {
    const image = getMasterBigPhotoById(noticia.player?.id);

    const equipo = obtenerEquipo(noticia?.player?.teamId, noticia?.player?.team?.id);

    const title = `${noticia?.player?.name} - ${equipo.name}: ${getPlayersStatus(
        noticia?.generalStatus?.status,
        noticia?.generalStatus?.statusLevel
    )}`;
    const h1 = `${noticia?.player?.name}: ${noticia?.generalStatus?.report}`;
    const description = `Última información de lesiones, sanciones, entrenamientos y todo lo relacionado a los jugadores en clave La Liga Fantasy, Dazn Biwenger, Marca y Comunio.`;
    const url = `${process.env.NEXT_PUBLIC_URL_FRONT}${Rutas.NOTICIAS_FLASH}/${noticia?.slug}`;

    return (
        <Box className="noticias-flash">
            <SeoNoticiasFlash
                title={title}
                description={description}
                url={url}
                image={image}
                author={noticia.author}
                date={noticia.created}
            />
            <Box className="container">
                <Typography variant="h1">{h1}</Typography>
                <NoticiasFlashSingleComponent noticia={noticia} h1={h1} />
            </Box>
        </Box>
    );
};

export default NoticiasFlashSinglePage;

// Implementación de SSR con getServerSideProps
export async function getServerSideProps(context) {
    const { slug } = context.params;
    const url = `${process.env.NEXT_PUBLIC_API}/noticia-flash/${slug}`;

    try {
        const response = await axiosApiInstance.get(url);

        return {
            props: {
                noticia: response.data,
            },
        };
    } catch (_error) {
        console.error('Error al obtener la noticia flash:', error.message);

        return {
            notFound: true,
        };
    }
}
